import Http from "@/libraries/Http";

export default {
    apiVersion: "v1",
    RESTroute: "project-actions",

    async GET_findPage(params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}/find-page`, {
            params: params
        });
    },

    async GET_linkable(project_id, action_type, params = {}) {
        return Http.get(
            `/${this.apiVersion}/${this.RESTroute}/linkable/${project_id}/${action_type}`,
            { params: params }
        );
    },

    async GET_shouldOpen(project_id, action_type, params = {}) {
        return Http.get(
            `/${this.apiVersion}/${this.RESTroute}/should-open/${project_id}/${action_type}`,
            { params: params }
        );
    },

    /**
     * Get all resources
     * GET /resource
     */
    async GET(params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}`, {
            params: params
        });
    },

    /**
     * Get single resource
     * GET /resource/<id>
     */
    async GETS(id, params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}/${id}`, {
            params: params
        });
    },

    /**
     * Create resource
     * POST /resource
     * Payload: {}
     */
    async POST(data) {
        return Http.post(`/${this.apiVersion}/${this.RESTroute}`, data);
    },

    /**
     * Put resource
     * PUT /resource/<id>
     * Payload: {}
     */
    async PUT(data) {
        return Http.put(
            `/${this.apiVersion}/${this.RESTroute}/${data.id}`,
            data
        );
    },

    /**
     * Delete resource
     * DELETE /resource/<id>
     */
    async DELETE(id) {
        return Http.delete(`/${this.apiVersion}/${this.RESTroute}/${id}`);
    },

    async POST_copyToProject(id) {
        return Http.post(
            `/${this.apiVersion}/${this.RESTroute}/copy-task-to-project/${id}`
        );
    }
};
